import axios from 'axios'
import { config } from '../config'

// API base URL - will be configured based on environment
const API_BASE_URL = config.apiUrl

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 300000, // 5 minutes timeout for AI generation
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor for logging
api.interceptors.request.use(
  (config) => {
    console.log(`Making ${config.method?.toUpperCase()} request to ${config.url}`)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.error('API Error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

// API endpoints
export const apiClient = {
  // Generate preview of the memecoin site
  generatePreview: async (formData) => {
    const response = await api.post('/api/generate-preview', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Publish the site to GitHub and get the live URL
  publishSite: async (data) => {
    const response = await api.post('/api/publish-site', data)
    return response.data
  },

  // Get site status (for checking if generation is complete)
  getSiteStatus: async (generationId) => {
    const response = await api.get(`/api/site-status/${generationId}`)
    return response.data
  },

  // Refine an existing site
  refineSite: async (data) => {
    const response = await api.post('/api/refine-site', data)
    return response.data
  },

  // Apply diff changes to existing HTML
  applyDiff: async (data) => {
    const response = await api.post('/api/apply-diff', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Get list of all generated sites (for directory page)
  getSitesList: async () => {
    const response = await api.get('/api/sites')
    return response.data
  },

  // Health check endpoint
  healthCheck: async () => {
    const response = await api.get('/api/health')
    return response.data
  }
}

export default api 